import { Show, createMemo, onMount } from "solid-js";

import { Button } from "@/components/Base/Button/Button.tsx";
import { getImageAltByLang } from "@/constants/seo-constants.ts";
import { useRouter } from "@/hooks/useRouter.tsx";
import { useI18n } from "@/i18n";
import BonusDropdownMenu from "@/layouts/pc/components/Header/BonusDropdownMenu.tsx";
import {
  getLocaleFromPath,
  getLocalizedPath,
  getRealPath,
} from "@/lib/language.ts";
import { getHeadImgurl } from "@/lib/resFolder";
import { sdkManager } from "@/lib/sdk/sdkManager.ts";
import { setProfileStore } from "@/stores/profileStore.ts";
import { userStore } from "@/stores/userStore.ts";

import HeaderWallet from "./HeaderWallet.tsx";

export default function HomeHeader(props: { isLandingPage?: boolean }) {
  const { push, pathname } = useRouter();
  const { t } = useI18n();
  const isLogin = createMemo(() => userStore.isLogin);
  const envName = import.meta.env.VITE_ENV_NAME;

  const setPathName = () => {
    // 要考虑多语言的情况,有多语言时要存去掉多语言的路径
    const locale = getLocaleFromPath(pathname());
    const path = window.location.pathname;
    if (locale) {
      return path.replace(`/${locale}`, "");
    }
    return path;
  };

  const onReport = (key: string, data: Record<string, unknown>) => {
    sdkManager.tdReportEvent(key, {
      ...data,
    });
  };

  const fromPage = () => {
    return window.location.pathname;
  };
  return (
    <div class="bg-up-di flex h-full w-full items-center justify-between px-3 transition-colors duration-300 ease-in-out">
      {/* Logo */}
      <div class="flex items-center">
        {/* <Link href="/"> */}
        <img
          src={
            envName === "prod"
              ? "/images/logo/logo.png"
              : "/images/kapok/logo.png"
          }
          width={65}
          height={29}
          alt={getImageAltByLang("logo")}
          class="h-[29px] w-[65px]"
          onClick={() => {
            onReport("afun_homepage_click", {
              from_page: fromPage(),
            });
            push("/");
          }}
        />
        {/* </Link> */}
      </div>
      <Show when={!isLogin()} fallback={<></>}>
        <div class="flex items-center gap-[10px]">
          <Show when={!props?.isLandingPage} fallback={<></>}>
            {/* 奖金中心 */}
            <BonusDropdownMenu />
          </Show>

          <Button
            variant="default"
            size="default"
            class="text-up-signin-zi min-w-[71px] px-[15px] text-[12px] font-[800] leading-[15px]"
            style={{ height: "35px", "border-radius": "5.25px" }}
            onClick={() => {
              onReport("signin_button_click", {
                from_page: fromPage(),
              });
              push("login");
            }}
          >
            {t("auth.sign_in")}
          </Button>
          <Button
            size="default"
            class="text-general-main bg-general-main10 min-w-[84px] px-[19px] text-[12px] font-[800] leading-[15px]"
            style={{ height: "35px", "border-radius": "5.25px" }}
            onClick={() => {
              onReport("signup_button_click", {
                from_page: fromPage(),
              });
              push("register");
            }}
          >
            {t("auth.sign_up")}
          </Button>
        </div>
      </Show>
      <Show when={isLogin() && !props?.isLandingPage} fallback={<></>}>
        <div class="flex gap-[6px]">
          <HeaderWallet />

          {/* 奖金中心 */}
          <BonusDropdownMenu />
          <div class="h-[34px] w-[34px] overflow-hidden rounded-[6px]">
            <img
              src={getHeadImgurl(Number(userStore.userInfo?.headimg))}
              alt="head"
              class="h-full w-full"
              onClick={() => {
                setProfileStore("from", setPathName());
                sdkManager.tdReportEvent("my_nav_click", {
                  source: fromPage(),
                });
                push("/profile");
              }}
            />
          </div>
        </div>
      </Show>
      <Show when={isLogin() && props?.isLandingPage} fallback={<></>}>
        <div
          id="user-dropdown-trigger"
          class="bg-general-icondi clickable border-up-stroke flex w-auto cursor-pointer items-center justify-center gap-[10px] rounded-[6px] border py-[2px] pl-[10px] pr-[2px]"
        >
          <div class="flex h-[31px] flex-col items-end">
            <span class="text-up-number1 h-4 text-xs font-medium">
              {userStore.userInfo?.nickname}
            </span>
            <span class="text-up-darkzi h-3 text-[10px] font-normal">
              ID:{userStore?.userInfo?.uid}
            </span>
          </div>
          <div class="size-[31px] overflow-hidden rounded-sm">
            <img
              src={getHeadImgurl(Number(userStore.userInfo?.headimg))}
              alt="head"
              class="h-full w-full"
            />
          </div>
        </div>
      </Show>
    </div>
  );
}
